<template>
  <b-container class="pt-5 mt-5 mb-5 custom-container weekly-page">
    <div class="weekly-head">
      <div>
        <h1 class="weekly-title">Weekly Timesheet</h1>
        <p class="text-muted mb-0">
          Fill in your week and send it to your supervisor for approval.
        </p>
      </div>
      <div class="weekly-switch">
        <b-button
          :variant="tab === 'submit' ? 'primary' : 'outline-secondary'"
          data-test="tab-submit"
          @click="tab = 'submit'"
        >
          Submit
        </b-button>
        <b-button
          :variant="tab === 'history' ? 'primary' : 'outline-secondary'"
          data-test="tab-history"
          @click="tab = 'history'"
        >
          History &amp; Status
        </b-button>
      </div>
    </div>

    <weekly-entry-form
      v-if="tab === 'submit'"
      :key="entryKey"
      :initial-project-id="target.projectId"
      :initial-week-start="target.weekStart"
      @sent="tab = 'history'"
    />
    <weekly-history-list v-else @amend="onAmend" />
  </b-container>
</template>

<script>
import WeeklyEntryForm from '@/components/timesheets/weekly/WeeklyEntryForm.vue'
import WeeklyHistoryList from '@/components/timesheets/weekly/WeeklyHistoryList.vue'

// Same two tabs as the app's Weekly view: Submit (edit and send the week) and
// History & Status. Opening a draft or amending a rejected week from history
// reopens Submit on that project and week.
export default {
  components: { WeeklyEntryForm, WeeklyHistoryList },

  data() {
    return {
      tab: 'submit',
      entryKey: 0,
      target: { projectId: null, weekStart: null },
    }
  },

  methods: {
    onAmend({ projectId, weekStart }) {
      this.target = { projectId, weekStart }
      this.entryKey++
      this.tab = 'submit'
    },
  },
}
</script>

<style lang="scss" scoped>
.weekly-head {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
}
.weekly-title {
  font-size: 1.6rem;
  font-weight: 700;
  margin-bottom: 4px;
}
.weekly-switch {
  display: flex;
  gap: 8px;
}
</style>
